"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.essDocumentsFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const authored_evidence_1 = require("../../../composite/evidence/authored-evidence/authored-evidence");
const evidence_1 = require("../../../composite/evidence/evidence");
const documents_fields_1 = require("./documents-fields");
const documents_columns_1 = require("./documents-columns");
function essDocumentsFactory(url, reportTag) {
    return function Documents() {
        const intl = react_intl_1.useIntl();
        const evidence = authored_evidence_1.useAuthoredEvidence({
            identifier: 'ESS_DOCUMENTS',
            apiProps: {
                url,
            },
            tableProps: {
                columns: documents_columns_1.useColumns(),
                tableName: intl.formatMessage({
                    id: 'ESS_DOCUMENTS_TABLE_TITLE',
                    defaultMessage: 'Dokumenty',
                }),
                reportTag,
            },
            detailProps: {
                FieldsComponent: documents_fields_1.DocumentsFields,
                toolbarProps: {
                    showButton: lodash_1.stubFalse,
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
    };
}
exports.essDocumentsFactory = essDocumentsFactory;
//# sourceMappingURL=documents.js.map